/**
 * <TypingIndicator> — « est en train d'écrire » (molecule).
 *
 * La bulle de l'autre, à sa place dans le fil, avec trois points à la place du texte — et les
 * MOTS dessous (« Sam réfléchit… ») : l'attente se dit, elle ne fait pas que clignoter. C'est la
 * suite d'un message que l'élève vient d'envoyer, pas un contenu qui charge.
 *
 * Elle sert Sam. Pour un tuteur, la présence n'existe pas hors live (l'en-tête de l'ancienne
 * messagerie lisait toujours « non connecté à la conversation ») : ne pas la monter côté tuteur.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { type ChampionName } from "../../atoms/Avatar/ChampionAvatar"
import { textLineBox } from "../../atoms/Skeleton/Skeleton"
import { TypingDots } from "../../atoms/TypingDots"
import { MESSAGE_BUBBLE_TEXT_SIZE } from "../MessageBubble"
import { MessageRow, type MessageSpeaker } from "../MessageRow"

export type TypingIndicatorProps = {
    /** Ce qui se lit sous la bulle, et que dit un lecteur d'écran — « Sam réfléchit… ». */
    label: string
    /** `agent` par défaut. */
    speaker?: MessageSpeaker
    /** L'agent est l'un des quatre : sa tête, posée par la ligne. */
    champion?: ChampionName
    /** La tête d'un agent hors casting. */
    avatar?: React.ReactNode
    testID?: string
}

const TYPING_MESSAGE = { id: "typing", author: "other" } as const

export function TypingIndicator(props: TypingIndicatorProps) {
    const { label, speaker = "agent", champion, avatar, testID } = props

    return (
        <View accessible accessibilityRole="text" accessibilityLabel={label} accessibilityLiveRegion="polite">
            <MessageRow
                message={TYPING_MESSAGE}
                speaker={speaker}
                tail
                champion={champion}
                avatar={avatar}
                caption={label}
                testID={testID}
            >
                <View style={styles.dots}>
                    <TypingDots />
                </View>
            </MessageRow>
        </View>
    )
}

const styles = StyleSheet.create(() => ({
    /** La hauteur d'une ligne de texte de bulle : la bulle des points a celle d'un message d'une ligne. */
    dots: {
        height: textLineBox(MESSAGE_BUBBLE_TEXT_SIZE),
        justifyContent: "center",
    },
}))
